import React, { useSyncExternalStore } from "react";

import { FilterContext } from "./FilterContext";
import { FilterState, FilterStoreSelector } from "./FilterStore";

export function useFilterStore<T extends readonly (keyof FilterState)[]>(
  fields: T
): {
  data: Pick<FilterState, T[number]>;
  setFilterState: (selector: FilterStoreSelector) => void;
  clearAllFilters: () => void;
};

export function useFilterStore<T extends readonly (keyof FilterState)[]>(
  fields: T
): {
  data: T extends readonly (keyof FilterState)[]
    ? Pick<FilterState, T[number]>
    : Pick<FilterState, keyof FilterState>;
  setFilterState: (selector: FilterStoreSelector) => void;
  clearAllFilters: () => void;
} {
  const store = React.useContext(FilterContext);
  const data = useSyncExternalStore(
    (callback) => store.subscribe(callback, fields),
    () => store.getState(),
    () => store.getState()
  );
  return {
    data: data as T extends readonly (keyof FilterState)[]
      ? Pick<FilterState, T[number]>
      : Pick<FilterState, keyof FilterState>,
    setFilterState: store.setState,
    clearAllFilters: store.clearAllFilters,
  };
}
